import { render } from "./LoginPopupRegComponent.vue?vue&type=template&id=49023c5d&scoped=true&ts=true"
import script from "./LoginPopupRegComponent.vue?vue&type=script&lang=ts"
export * from "./LoginPopupRegComponent.vue?vue&type=script&lang=ts"

import "./LoginPopupRegComponent.vue?vue&type=style&index=0&id=49023c5d&scoped=true&lang=css"
import "./LoginPopupRegComponent.vue?vue&type=style&index=1&id=49023c5d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49023c5d"]])

export default __exports__